<template>
    <v-dialog class="rounded-0" v-model="isActive" width="500" persistent transition="dialog-bottom-transition">
        <v-card>
            <v-card-text class="d-flex flex-row justify-center ma-0">
                <v-icon color="orange darken-2" size="120" class="mt-3">mdi-alert-circle-outline</v-icon>
            </v-card-text>
            <!--  <v-progress-linear v-if="loading" indeterminate height="5" color="orange"></v-progress-linear> -->
            <v-card-text class="d-flex font-weight-regular text-body-1 black--text ">
                <div v-html="formatText(text)"></div>
            </v-card-text>
            <v-card-text class="d-flex flex-column align-center">
                <v-btn v-if="tipo == 'contacto'" @click="gotToView" width="250px" elevation="0" color="primary"
                    class="pa-5 mb-1">
                    {{ tipo }}
                </v-btn>
                <v-btn v-else @click="continuar(true)" width="250px" elevation="0" color="primary" class="pa-5 mb-1">
                    Quiero que me llamen
                </v-btn>
                <v-btn outlined @click="continuar(false)" width="250px" elevation="0" color="secondary" class="pa-5">
                    cerrar
                </v-btn>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
export default {
    props: ['titulo'],
    data() {
        return {
            isActive: false,
            callback: null,

            text: "Comunicáte con tu Delegación Distrital para verificar el cumplimiento de los requisitos."
        }
    },
    mounted() {
    },
    methods: {
        ...mapActions('auth', ['cerrarSesion', 'refreshToken']),

        formatText(text) {
            const boldTexts = [
                'Subsidio',
                'sujeta a revisión',
            ];

            // Use a regular expression to replace each occurrence of the bold texts with their bolded versions
            boldTexts.forEach(boldText => {
                const regex = new RegExp(boldText, 'g');
                text = text.replace(regex, `<b>${boldText}</b>`);
            });

            // Cambia de línea después de cada punto seguido de un espacio
            text = text.replace(/\. /g, '.<br>');
            return text;
        },

        abrirDialog() {
            this.isActive = true;
            return new Promise(resolve => {
                this.callback = resolve;
            })
        },
        continuar(result) {
            if (this.callback) {
                this.callback(result);
                this.callback = null; // Reset the callback to avoid memory leaks
            }
            this.isActive = false
        },

        gotToView() {
            this.$router.push('/mediosDeContacto').catch(() => { })
        },
    },
    computed: {
        ...mapGetters('auth', ['user'])
    },
    props: {
        tipo: {
            type: String,
            default: 'contacto',
            required: false
        }
    }
}

</script>